import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Injectable({
  providedIn: 'root'
})
export class AccountTypeGuardService  {

  constructor(
    public router: Router, 
    public localStorageService: AbstractLocalStorageService,
    public personalUserDataService: AbstractPersonalUserDataService) {}
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log(`AccountTypeGuardService user accountType ${this.personalUserDataService.getLoggedInUserPersonalData()?.accountType}`);

    const allowedAccountTypes = route.data.accountTypes as Array<number>;
    const userDetails = this.personalUserDataService.getLoggedInUserPersonalData();

    // console.log (`AccountTypeGuardService allowedAccountTypes ${allowedAccountTypes} user account type is ${userDetails!.accountType}`);

    if (userDetails == undefined ||  
      !allowedAccountTypes.includes(userDetails.accountType)) {
      this.localStorageService.write<string>(LocalStorageKeys.returnUrl, state.url);
      // console.log (`AccountTypeGuardService NOGO`);
            this.router.navigate([NAVIGATION_ROUTES.app.personalView], { state: { redirect: state.url } });
      return false;
    } else {
      // console.log (`AccountTypeGuardService GO`);
      return true;  
    }
  }
}
